/**
 * The prefix every Test View route lives under, on Pro Studio's own origin.
 *
 * Its own module so the CLIENT can import it without pulling the router in
 * behind it — the router reaches the runner, the runner reaches Phoenix and
 * `node:crypto`, and Vite externalizes both in a browser build.
 */
export const TEST_API_PREFIX = '/test';
